import Tooltip from 'src/components/primitives/Tooltip/Tooltip';
import WarningFilled from 'src/components/Icons/WarningFilled';

interface UnclaimablePnlWarningProps {
	warningMessage: string;
}

export function UnclaimablePnlWarning({
	warningMessage,
}: UnclaimablePnlWarningProps) {
	return (
		<Tooltip content={warningMessage} decoration="none">
			<WarningFilled size={12} className="text-star-yellow" />
		</Tooltip>
	);
}
